export default function({ state, commit, dispatch }, { id, provider, schedule, questionnaire_notes, emr_category, combined_notes, note, questions_responses, emrs }) {
    let query = {
        emr_category,
        schedule,
        questions_responses,
        emrs
    }

    if(questionnaire_notes)
        query.questionnaire_notes = questionnaire_notes

    if(combined_notes)
        query.combined_notes = combined_notes


    if(note)
        query.note = note
    
    
    return dispatch('post', {
        url: '/provider/' + (state.id ? state.id : provider) + '/patient/' + id + '/chart',
        data: {
            ...query
        }
    }, {
        root: true
    })
    .then((response) => {
        if(response.success)
            commit('updateIntegration', { ...query, id})
        return response
    })
    .catch((error) => {
        throw error
    })
}
